module.exports = __webpack_public_path__ + "img/bespoke70_31.60e09c8a.jpg";